export default __webpack_public_path__ + "static/media/WINE5.b9d72404.jpg";